import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';
import Button from 'carbon-react/lib/components/button';

import { ROUTES, getForecastByIdOnboardingUrl } from '@futrli/shared-services';

import * as styles from '../forecasting-onboarding.scss';
import { OnboardingPageTitle } from '../components/onboarding-page-title';
import { OnboardingPredictionsRouter } from '../components/onboarding-predictions-router';
import {
  LS_FORECASTING_ONBOARDING_STEP,
  SCENARIO_ONBOARDING_STEP,
  SCENARIO_WITH_INVOICES_ONBOARDING_STEP
} from '../const';
import { useOnboardingUrlInfo } from '../utils/hooks';
import { ForecastType } from '../shared/onboarding-type-select';
import { VIEW_TYPES } from '../../../core/types';
import { usePredictionsInfoContext } from '../../detail/context/predictions-info-context';

export const OnboardingControlCashflow = () => {
  const navigate = useNavigate();
  const { forecast, viewType, setViewType } = usePredictionsInfoContext();
  const { workspaceId: tempWorkspaceId, organisationId: tempOrganisationId } = useParams();

  const workspaceId = tempWorkspaceId || '';
  const organisationId = tempOrganisationId || '';

  const { forecastType, isOnboardingScenarioRoute, isOnboardingScenarioWithInvoicesRoute } = useOnboardingUrlInfo();

  const handleNextClick = () => {
    if (!forecast) {
      return;
    }

    let nextStep;
    if (isOnboardingScenarioRoute) {
      nextStep =
        forecastType === ForecastType.FromScratch
          ? SCENARIO_ONBOARDING_STEP.SCRATCH_ADDITIONAL_CONTROLS
          : forecastType === ForecastType.WithAutoPredictions
          ? SCENARIO_ONBOARDING_STEP.AUTO_PREDICTIONS_ADDITIONAL_CONTROLS
          : SCENARIO_ONBOARDING_STEP.LYA_ADDITIONAL_CONTROLS;
    } else {
      nextStep =
        forecastType === ForecastType.FromScratch
          ? SCENARIO_WITH_INVOICES_ONBOARDING_STEP.SCRATCH_ADDITIONAL_CONTROLS
          : forecastType === ForecastType.WithAutoPredictions
          ? SCENARIO_WITH_INVOICES_ONBOARDING_STEP.AUTO_PREDICTIONS_ADDITIONAL_CONTROLS
          : SCENARIO_WITH_INVOICES_ONBOARDING_STEP.LYA_ADDITIONAL_CONTROLS;
    }

    if (viewType === VIEW_TYPES.CASH_FLOW) {
      setViewType?.(VIEW_TYPES.ACCRUALS_PL);
    }

    navigate(
      `${getForecastByIdOnboardingUrl(
        workspaceId,
        organisationId,
        forecast.id,
        false,
        isOnboardingScenarioWithInvoicesRoute
      )}/${nextStep}${ROUTES.SALES}${location.search}`
    );
    localStorage.setItem(LS_FORECASTING_ONBOARDING_STEP, nextStep);
  };

  return (
    <div className={styles.contentContainer} style={{ position: 'relative' }}>
      <OnboardingPageTitle
        title={
          <FormattedMessage
            id="onboarding.control_of_cash_flow"
            defaultMessage="Get control of your cash flow here, as you build..."
          />
        }
        description={
          <FormattedMessage
            id="onboarding.average_days_to_pay"
            defaultMessage="Average days to pay are calculated for every account, to give you insights as you create predictions."
          />
        }
      />
      <Button disabled={!forecast} mb="30px" buttonType="primary" size="large" onClick={handleNextClick}>
        <FormattedMessage id="common.next" defaultMessage="Next" />
      </Button>
      <OnboardingPredictionsRouter />
    </div>
  );
};
